import { Text } from "@mantine/core"
import { UserComboboxItem } from "./AbsenceUserWithEmailInfoSelect"

export function userSelectRenderOptionWithEmailAddressWarning(
  item: UserComboboxItem
) {
  return (
    <>
      <Text>{item.option.label} </Text>
      {item.option.secondaryLabel ? (
        <Text c="gray">{item.option.secondaryLabel} </Text>
      ) : null}
      {item.option.hasPrimaryEmail ||
      item.option.userType == "UserGroup" ? null : (
        <Text c="yellow">(Ohne Emailadresse)</Text>
      )}
    </>
  )
}
